import React, { useEffect, useState } from 'react';
import { XFilled } from '@weee-fe/kunlunicon';
import { isSayWeeeApp } from '@/utils/common/device';
import callAppFunction from '@/utils/bridge';
import { appOnPopupWindowDidFinish } from '@/utils/business';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import Button from '@/components/common/Button';
import BANNER from '@/assets/images/gift-card/intro.png';
import { CroppedImage } from '@weee-fe/module';

interface Props {
  data?: any;
  visible?: boolean;
  onCancel?: () => void;
}

const GiftCardIntro = (props: Props) => {
  const router = useRouter();
  const { visible, onCancel, data } = props;
  const { t, lang } = useTranslation('common');

  useEffect(() => {
    if (isSayWeeeApp()) {
      const popup = () => {
        const popheight = +router?.query?.['__popup_height__'] || 300;
        let show = false;
        const args = {
          width: -1,
          height: popheight
        };
        callAppFunction('popupWindowSizeChanged', args, function (res) {});
        if (!show) {
          appOnPopupWindowDidFinish();
          show = true;
        }
      };
      popup();
    }
  }, []);

  return (
    <div id="popcontainer" className="relative">
      <div
        className="fixed right-0 flex items-center justify-center left-3 top-3 w-9 h-9 rounded-full bg-[#FFFFFFCC]"
        onClick={onCancel}>
        <XFilled className="text-[20px]" />
      </div>
      <div className="text-left">
        <CroppedImage
          alt={t('gift_card_intro_title')}
          url={BANNER}
          wrapperClassName="h-[186px] w-full"
          className="w-full h-full object-cover"></CroppedImage>
        <div className="p-5">
          <p className="enki-heading-2xl text-surface-100-fg-default !leading-[1.2] mb-2">
            {t('gift_card_intro_title')}
          </p>
          <p className="enki-body-lg">{t('gift_card_intro_desc')}</p>
          <Button onClick={onCancel} className="bg-btn-secondary-bg text-white w-auto mx-auto mt-5 px-5">
            {t('gift_card_intro_confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GiftCardIntro;
